export const MAX_CONTAINER_WIDTH = 1092
export const BACK_TO_DASHBOARD = 'Back to Dashboard'
export const IS_NEW_LAYOUT_ENABLED = true
export const IS_DOC_LAYOUT_ENABLED = true
export const NEW_CONTAINER_WIDTH = 1440
export const VECHILE_CONTAINER_WIDTH = 1104
export const NEW_ACCORDIAN_WIDTH = 656
export const NEW_RES_ACCORDIAN_WIDTH = 572
export const DOCUMENT_UPLOAD_CONTAINER = 657
export const DOCUMENT_UPLOAD_SM_CONTAINER = 527
export const DOCUMENT_FOOTER_SMD_CONTAINER = 464
export const DOCUMENT_FOOTER_MD_CONTAINER = 560
export const DOCUMENT_CARD_MD_WIDTH = 600
